import styled from "@emotion/styled";
import { Typography } from "../Typography";
import { Wrapper } from "../Wrapper";

export const ImpactShopHeroContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.forest};
  text-align: center;
  display: grid;
  align-items: center;
  grid-template-columns: 50% 50%;
  grid-template-areas:
    "header header"
    "img1 img2";
  @media ${(props) => props.theme.bp.mobileUp} {
    grid-template-areas: "img1 header img2";
    grid-template-columns: 25% auto 25%;
    grid-template-rows: auto;
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 14px;
`;

export const WhiteTypography = styled(Typography)`
  color: ${({ theme }) => theme.colors.snowdrop};
`;

export const HeaderImage = styled.div<{
  gridArea: string;
  position: "left" | "right";
  imageUrlDesktop: string;
  imageUrlMobile: string;
  mobileHeight: number;
  mobileWidth: number;
  mobileLeftMargin?: number;
  mobileRightMargin?: number;
}>`
  grid-area: ${(props) => props.gridArea};
  background-repeat: no-repeat;
  background-position: bottom ${(props) => props.position};
  background-size: contain;
  min-height: 275px;
  height: 100%;
  width: 100%;
  background-image: url(${(props) => props.imageUrlDesktop});
  @media ${(props) => props.theme.bp.mobileDown} {
    min-height: 0;
    align-self: end;
    margin-left: ${(props) => props.mobileLeftMargin || 0}px;
    margin-right: ${(props) => props.mobileRightMargin || 0}px;
    height: ${(props) => props.mobileHeight}px;
    width: ${(props) => props.mobileWidth}px;
    background-image: url(${(props) => props.imageUrlMobile});
  }
`;

export const ImageContainer = styled.div<{ position: "left" | "right" }>`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: ${(props) =>
    props.position === "left" ? "flex-start" : "flex-end"};
`;

export const TextWrapper = styled(Wrapper)`
  grid-area: header;
  @media ${(props) => props.theme.bp.mobileDown} {
    padding-bottom: 18px;
  }
`;
